'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    posthog.captureException(error, {
      description: '[Error] Page-level error occurred',
      error,
    });
  }, [error]);

  return (
    <div className="fixed inset-0 flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md p-6">
        <div className="flex flex-col items-center gap-4">
          <Alert variant="destructive" className="w-full">
            <AlertTitle>Something went wrong</AlertTitle>
            <AlertDescription>
              We've logged this error and will look into it.
            </AlertDescription>
          </Alert>
          <Button onClick={reset} className="mt-4 flex items-center gap-2">
            <RefreshCw className="h-4 w-4" />
            <span>Try again</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
